const localPermissions = {
  ADMIN_ADD_COLLABORATOR: {
    category: 'admin_collaborator_management',
    title: 'admin_add_collaborator',
    type: 'ADMIN'
  },
  ADMIN_UPDATE_COLLABORATOR: {
    category: 'admin_collaborator_management',
    title: 'admin_update_collaborator',
    type: 'ADMIN'
  },
  ADMIN_DELETE_COLLABORATOR: {
    category: 'admin_collaborator_management',
    title: 'admin_delete_collaborator',
    type: 'ADMIN'
  },
  ADMIN_ADD_REPAIR_FILE: {
    category: 'admin_repair_file_management',
    title: 'admin_add_repair_file',
    type: 'ADMIN'
  },
  ADMIN_UPDATE_REPAIR_FILE: {
    category: 'admin_repair_file_management',
    title: 'admin_update_repair_file',
    type: 'ADMIN'
  },
  ADMIN_CLOSE_REPAIR_FILE: {
    category: 'admin_repair_file_management',
    title: 'admin_close_repair_file',
    type: 'ADMIN'
  },
  ADMIN_DELETE_REPAIR_FILE: {
    category: 'admin_repair_file_management',
    title: 'admin_delete_repair_file',
    type: 'ADMIN'
  },
  ADMIN_COMMENT_REPAIR_FILE: {
    category: 'admin_repair_file_management',
    title: 'admin_comment_repair_file',
    type: 'ADMIN'
  },
  ADMIN_REMOVE_ATTACHMENT_REPAIR_FILE: {
    category: 'admin_repair_file_management',
    title: 'admin_remove_attachment_repair_file',
    type: 'ADMIN'
  },
  ADMIN_REMOVE_COMMENT_REPAIR_FILE: {
    category: 'admin_repair_file_management',
    title: 'admin_remove_comment_repair_file',
    type: 'ADMIN'
  },
  ADMIN_VIEW_ALL_SUMMARY_REPAIR_FILE: {
    category: 'admin_repair_file_view',
    title: 'admin_view_all_summary_repair_file',
    type: 'ADMIN'
  },
  ADMIN_VIEW_ATTACHMENT_REPAIR_FILE: {
    category: 'admin_repair_file_view',
    title: 'admin_view_attachment_repair_file',
    type: 'ADMIN'
  },
  ADMIN_VIEW_REPAIR_FILE: {
    category: 'admin_repair_file_view',
    title: 'admin_view_repair_file',
    type: 'ADMIN'
  },
  ADMIN_PRINT_ATTACHMENT_REPAIR_FILE: {
    category: 'admin_repair_file_view',
    title: 'admin_print_attachment_repair_file',
    type: 'ADMIN'
  },
  ADMIN_ADD_ATTACHMENT_REPAIR_FILE: {
    category: 'admin_repair_file_view',
    title: 'admin_add_attachment_repair_file',
    type: 'ADMIN'
  },
  ADMIN_ACCOUNT_CREATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_account_create_permission',
    type: 'ADMIN'
  },
  ADMIN_ACCOUNT_READ_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_account_read_permission',
    type: 'ADMIN'
  },
  ADMIN_ACCOUNT_UPDATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_account_update_permission',
    type: 'ADMIN'
  },
  ADMIN_ACCOUNT_DELETE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_account_delete_permission',
    type: 'ADMIN'
  },
  ADMIN_ROLE_CREATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_role_create_permission',
    type: 'ADMIN'
  },
  ADMIN_ROLE_READ_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_role_read_permission',
    type: 'ADMIN'
  },
  ADMIN_ROLE_UPDATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_role_update_permission',
    type: 'ADMIN'
  },
  ADMIN_ROLE_DELETE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_role_delete_permission',
    type: 'ADMIN'
  },
  ADMIN_PRODUCT_CREATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_product_create_permission',
    type: 'ADMIN'
  },
  ADMIN_PRODUCT_READ_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_product_read_permission',
    type: 'ADMIN'
  },
  ADMIN_PRODUCT_UPDATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_product_update_permission',
    type: 'ADMIN'
  },
  ADMIN_PRODUCT_DELETE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_product_delete_permission',
    type: 'ADMIN'
  },
  ADMIN_DISTRIBUTOR_NETWORK_CREATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_distributor_network_create_permission',
    type: 'ADMIN'
  },
  ADMIN_DISTRIBUTOR_NETWORK_READ_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_distributor_network_read_permission',
    type: 'ADMIN'
  },
  ADMIN_DISTRIBUTOR_NETWORK_UPDATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_distributor_network_update_permission',
    type: 'ADMIN'
  },
  ADMIN_DISTRIBUTOR_NETWORK_DELETE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_distributor_network_delete_permission',
    type: 'ADMIN'
  },
  ADMIN_STORE_CREATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_store_create_permission',
    type: 'ADMIN'
  },
  ADMIN_STORE_READ_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_store_read_permission',
    type: 'ADMIN'
  },
  ADMIN_STORE_UPDATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_store_update_permission',
    type: 'ADMIN'
  },
  ADMIN_STORE_DELETE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_store_delete_permission',
    type: 'ADMIN'
  },
  ADMIN_KEY_ACCOUNT_NETWORK_CREATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_key_account_network_create_permission',
    type: 'ADMIN'
  },
  ADMIN_KEY_ACCOUNT_NETWORK_READ_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_key_account_network_read_permission',
    type: 'ADMIN'
  },
  ADMIN_KEY_ACCOUNT_NETWORK_UPDATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_key_account_network_update_permission',
    type: 'ADMIN'
  },
  ADMIN_KEY_ACCOUNT_NETWORK_DELETE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_key_account_network_delete_permission',
    type: 'ADMIN'
  },
  ADMIN_KEY_ACCOUNT_PRODUCT_READ_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_key_account_product_read_permission',
    type: 'ADMIN'
  },
  ADMIN_KEY_ACCOUNT_PRODUCT_CREATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_key_account_product_create_permission',
    type: 'ADMIN'
  },
  ADMIN_KEY_ACCOUNT_PRODUCT_UPDATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_key_account_product_update_permission',
    type: 'ADMIN'
  },
  ADMIN_KEY_ACCOUNT_PRODUCT_REQUEST_DRAFT_REVIEW_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_key_account_product_request_draft_review_permission',
    type: 'ADMIN'
  },
  ADMIN_KEY_ACCOUNT_GROUP_CREATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_key_account_group_create_permission',
    type: 'ADMIN'
  },
  ADMIN_KEY_ACCOUNT_GROUP_READ_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_key_account_group_read_permission',
    type: 'ADMIN'
  },
  ADMIN_KEY_ACCOUNT_GROUP_UPDATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_key_account_group_update_permission',
    type: 'ADMIN'
  },
  ADMIN_KEY_ACCOUNT_GROUP_DELETE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_key_account_group_delete_permission',
    type: 'ADMIN'
  },
  ADMIN_OPERATING_CENTER_CREATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_operating_center_create_permission',
    type: 'ADMIN'
  },
  ADMIN_OPERATING_CENTER_READ_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_operating_center_read_permission',
    type: 'ADMIN'
  },
  ADMIN_OPERATING_CENTER_UPDATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_operating_center_update_permission',
    type: 'ADMIN'
  },
  ADMIN_OPERATING_CENTER_DELETE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_operating_center_delete_permission',
    type: 'ADMIN'
  },
  ADMIN_TRANSPORTER_CREATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_transporter_create_permission',
    type: 'ADMIN'
  },
  ADMIN_TRANSPORTER_READ_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_transporter_read_permission',
    type: 'ADMIN'
  },
  ADMIN_TRANSPORTER_UPDATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_transporter_update_permission',
    type: 'ADMIN'
  },
  ADMIN_TRANSPORTER_DELETE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_transporter_delete_permission',
    type: 'ADMIN'
  },
  ADMIN_REPAIRER_CREATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_repairer_create_permission',
    type: 'ADMIN'
  },
  ADMIN_REPAIRER_READ_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_repairer_read_permission',
    type: 'ADMIN'
  },
  ADMIN_REPAIRER_UPDATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_repairer_update_permission',
    type: 'ADMIN'
  },
  ADMIN_REPAIRER_DELETE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_repairer_delete_permission',
    type: 'ADMIN'
  },
  ADMIN_BILLING_CREATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_billing_create_permission',
    type: 'ADMIN'
  },
  ADMIN_BILLING_READ_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_billing_read_permission',
    type: 'ADMIN'
  },
  ADMIN_BILLING_UPDATE_PERMISSION: {
    category: 'admin_platform_management',
    title: 'admin_billing_update_permission',
    type: 'ADMIN'
  },
  ADMIN_CREATE_NOTIFICATION: {
    category: 'admin_platform_management',
    title: 'admin_create_notification',
    type: 'ADMIN'
  },
  ADMIN_CHECK_CLOUD_STORAGE_INTEGRITY: {
    category: 'admin_platform_management',
    title: 'admin_check_cloud_storage_integrity',
    type: 'ADMIN'
  },
  ADMIN_EMAIL_OUTBOX_READ: {
    category: 'admin_platform_management',
    title: 'admin_email_outbox_read',
    type: 'ADMIN'
  },
  ADMIN_EMAIL_OUTBOX_RESEND: {
    category: 'admin_platform_management',
    title: 'admin_email_outbox_resend',
    type: 'ADMIN'
  },
  ADMIN_HISTORY_ACTION_READ: {
    category: 'admin_platform_management',
    title: 'admin_history_action_read',
    type: 'ADMIN'
  },
  ADMIN_ITECH_MANUAL_UPDATE: {
    category: 'admin_platform_management',
    title: 'admin_itech_manual_update',
    type: 'ADMIN'
  },
  ADMIN_CHRONOPOST_MANUAL_UPDATE: {
    category: 'admin_platform_management',
    title: 'admin_chronopost_manual_update',
    type: 'ADMIN'
  },
  ADMIN_RENTAL_READ: {
    category: 'admin_rental',
    title: 'admin_rental_read',
    type: 'ADMIN'
  },
  ADMIN_RENTAL_CREATE: {
    category: 'admin_rental',
    title: 'admin_rental_create',
    type: 'ADMIN'
  },
  ADMIN_RENTAL_UPDATE: {
    category: 'admin_rental',
    title: 'admin_rental_update',
    type: 'ADMIN'
  },
  ADMIN_RENTAL_DELETE: {
    category: 'admin_rental',
    title: 'admin_rental_delete',
    type: 'ADMIN'
  },
  ADMIN_RECYCLING_READ: {
    category: 'admin_recycling',
    title: 'admin_recycling_read',
    type: 'ADMIN'
  },
  ADMIN_RECYCLING_CREATE: {
    category: 'admin_recycling',
    title: 'admin_recycling_create',
    type: 'ADMIN'
  },
  ADMIN_RECYCLING_UPDATE: {
    category: 'admin_recycling',
    title: 'admin_recycling_update',
    type: 'ADMIN'
  },
  ADMIN_RECYCLING_DELETE: {
    category: 'admin_recycling',
    title: 'admin_recycling_delete',
    type: 'ADMIN'
  },

  ADMIN_EXTRACT_REPAIR_FILE: {
    category: 'admin_extract_management',
    title: 'admin_extract_repair_file',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_ACCOUNT: {
    category: 'admin_extract_management',
    title: 'admin_extract_account',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_ROLE: {
    category: 'admin_extract_management',
    title: 'admin_extract_role',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_DISTRIBUTOR_NETWORK_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_distributor_network_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_KEY_ACCOUNT_NETWORK_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_key_account_network_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_KEY_ACCOUNT_GROUP_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_key_account_group_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_DISTRIBUTOR_GROUP_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_distributor_group_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_STORE_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_store_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_OPERATING_CENTER_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_operating_center_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_CATEGORY_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_category_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_PRODUCT_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_product_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_KEY_ACCOUNT_PRODUCT_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_key_account_product_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_PACKAGE_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_package_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_SERIAL_NUMBER_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_serial_number_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_GUARANTEE_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_guarantee_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_GUARANTEE_EXTENSION_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_guarantee_extension_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_PRODUCT_BREAKDOWN_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_product_breakdown_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_PRODUCT_DISTRIBUTOR_REF_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_product_distributor_ref_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_PRODUCT_STORE_PRICE_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_product_store_price_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_REPAIRER_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_repairer_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_ADDITIONAL_REPAIR_COST_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_additional_repair_cost_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_TRANSPORT_PACKAGE_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_transport_package_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_TRANSPORTER_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_transporter_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_ESTIMATE_TRANSPORTER_COST_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_estimate_transporter_cost_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_RENTAL_PRODUCT_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_rental_product_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_RECYCLER_BAC_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_recycler_bac_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_RECYCLING_BUYBACK_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_recycling_buyback_referential',
    type: 'ADMIN'
  },
  ADMIN_EXTRACT_RECYCLING_CLIENT_LINK_REFERENTIAL: {
    category: 'admin_extract_management',
    title: 'admin_extract_recycling_client_link_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_REPAIR_FILE_UPDATE_STATUS: {
    category: 'admin_import_management',
    title: 'admin_import_repair_file_update_status',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_PRODUCT_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_product_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_PACKAGE_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_package_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_SERIAL_NUMBER_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_serial_number_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_GUARANTEE_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_guarantee_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_GUARANTEE_EXTENSION_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_guarantee_extension_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_PRODUCT_BREAKDOWN_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_product_breakdown_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_PRODUCT_DISTRIBUTOR_REF_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_product_distributor_ref_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_PRODUCT_STORE_PRICE_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_product_store_price_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_REPAIRER_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_repairer_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_ADDITIONAL_REPAIR_COST_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_additional_repair_cost_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_TRANSPORT_PACKAGE_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_transport_package_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_TRANSPORTER_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_transporter_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_ESTIMATE_TRANSPORTER_COST_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_estimate_transporter_cost_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_RENTAL_PRODUCT_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_rental_product_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_RECYCLER_BAC_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_recycler_bac_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_RECYCLING_BUYBACK_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_recycling_buyback_referential',
    type: 'ADMIN'
  },
  ADMIN_IMPORT_RECYCLING_CLIENT_LINK_REFERENTIAL: {
    category: 'admin_import_management',
    title: 'admin_import_recycling_client_link_referential',
    type: 'ADMIN'
  },
  ADMIN_KEY_ACCOUNT_PRODUCT_IMPORT_PERMISSION: {
    category: 'admin_import_management',
    title: 'admin_key_account_product_import_permission',
    type: 'ADMIN'
  },

  DISTRIBUTOR_RENTAL_READ: {
    category: 'distributor_rental',
    title: 'distributor_rental_read',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_RENTAL_CREATE: {
    category: 'distributor_rental',
    title: 'distributor_rental_create',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_RENTAL_UPDATE: {
    category: 'distributor_rental',
    title: 'distributor_rental_update',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_RENTAL_DELETE: {
    category: 'distributor_rental',
    title: 'distributor_rental_delete',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_RECYCLING_READ: {
    category: 'distributor_recycling',
    title: 'distributor_recycling_read',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_RECYCLING_CREATE: {
    category: 'distributor_recycling',
    title: 'distributor_recycling_create',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_RECYCLING_UPDATE: {
    category: 'distributor_recycling',
    title: 'distributor_recycling_update',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_RECYCLING_DELETE: {
    category: 'distributor_recycling',
    title: 'distributor_recycling_delete',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_EXTRACT_REPAIR_FILE: {
    category: 'distributor_extract_management',
    title: 'distributor_extract_repair_file',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_ADD_COLLABORATOR: {
    category: 'distributor_collaborator_management',
    title: 'distributor_add_collaborator',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_UPDATE_COLLABORATOR: {
    category: 'distributor_collaborator_management',
    title: 'distributor_update_collaborator',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_DELETE_COLLABORATOR: {
    category: 'distributor_collaborator_management',
    title: 'distributor_delete_collaborator',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_ADD_REPAIR_FILE: {
    category: 'distributor_repair_file_management',
    title: 'distributor_add_repair_file',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_UPDATE_REPAIR_FILE: {
    category: 'distributor_repair_file_management',
    title: 'distributor_update_repair_file',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_CLOSE_REPAIR_FILE: {
    category: 'distributor_repair_file_management',
    title: 'distributor_close_repair_file',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_DELETE_REPAIR_FILE: {
    category: 'distributor_repair_file_management',
    title: 'distributor_delete_repair_file',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_ESTIMATE_OVERRIDE_REPAIR_FILE: {
    category: 'distributor_repair_file_management',
    title: 'distributor_estimate_override_repair_file',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_VIEW_ALL_SUMMARY_REPAIR_FILE: {
    category: 'distributor_repair_file_view',
    title: 'distributor_view_all_summary_repair_file',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_VIEW_ATTACHMENT_REPAIR_FILE: {
    category: 'distributor_repair_file_view',
    title: 'distributor_view_attachment_repair_file',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_VIEW_REPAIR_FILE: {
    category: 'distributor_repair_file_view',
    title: 'distributor_view_repair_file',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_PRINT_ATTACHMENT_REPAIR_FILE: {
    category: 'distributor_repair_file_view',
    title: 'distributor_print_attachment_repair_file',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_ADD_ATTACHMENT_REPAIR_FILE: {
    category: 'distributor_repair_file_view',
    title: 'distributor_add_attachment_repair_file',
    type: 'DISTRIBUTOR'
  },
  KEY_ACCOUNT_ADD_REPAIR_FILE: {
    category: 'key_account_repair_file_management',
    title: 'key_account_add_repair_file',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_UPDATE_REPAIR_FILE: {
    category: 'key_account_repair_file_management',
    title: 'key_account_update_repair_file',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_CLOSE_REPAIR_FILE: {
    category: 'key_account_repair_file_management',
    title: 'key_account_close_repair_file',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_DELETE_REPAIR_FILE: {
    category: 'key_account_repair_file_management',
    title: 'key_account_delete_repair_file',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_COMMENT_REPAIR_FILE: {
    category: 'key_account_repair_file_view',
    title: 'key_account_comment_repair_file',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_VIEW_ALL_SUMMARY_REPAIR_FILE: {
    category: 'key_account_repair_file_view',
    title: 'key_account_view_all_summary_repair_file',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_VIEW_ATTACHMENT_REPAIR_FILE: {
    category: 'key_account_repair_file_view',
    title: 'key_account_view_attachment_repair_file',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_VIEW_REPAIR_FILE: {
    category: 'key_account_repair_file_view',
    title: 'key_account_view_repair_file',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_PRINT_ATTACHMENT_REPAIR_FILE: {
    category: 'key_account_repair_file_view',
    title: 'key_account_print_attachment_repair_file',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_ADD_ATTACHMENT_REPAIR_FILE: {
    category: 'key_account_repair_file_view',
    title: 'key_account_add_attachment_repair_file',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_EXTRACT_REPAIR_FILE: {
    category: 'key_account_extract_management',
    title: 'key_account_extract_repair_file',
    type: 'KEY_ACCOUNT'
  },
  DISTRIBUTOR_ACCOUNT_READ_PERMISSION: {
    category: 'distributor_platform_management',
    title: 'distributor_account_read_permission',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_ACCOUNT_UPDATE_PERMISSION: {
    category: 'distributor_platform_management',
    title: 'distributor_account_update_permission',
    type: 'DISTRIBUTOR'
  },
  DISTRIBUTOR_TRANSPORTER_READ_PERMISSION: {
    category: 'distributor_platform_management',
    title: 'distributor_transporter_read_permission',
    type: 'DISTRIBUTOR'
  },
  KEY_ACCOUNT_ACCOUNT_READ_PERMISSION: {
    category: 'key_account_platform_management',
    title: 'key_account_account_read_permission',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_PRODUCT_READ_PERMISSION: {
    category: 'key_account_platform_management',
    title: 'key_account_product_read_permission',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_PRODUCT_CREATE_REQUEST_PERMISSION: {
    category: 'key_account_platform_management',
    title: 'key_account_product_create_request_permission',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_PRODUCT_UPDATE_PERMISSION: {
    category: 'key_account_platform_management',
    title: 'key_account_product_update_permission',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_TRANSPORTER_CREATE_PERMISSION: {
    category: 'key_account_platform_management',
    title: 'key_account_transporter_create_permission',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_TRANSPORTER_READ_PERMISSION: {
    category: 'key_account_platform_management',
    title: 'key_account_transporter_read_permission',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_TRANSPORTER_UPDATE_PERMISSION: {
    category: 'key_account_platform_management',
    title: 'key_account_transporter_update_permission',
    type: 'KEY_ACCOUNT'
  },
  KEY_ACCOUNT_TRANSPORTER_DELETE_PERMISSION: {
    category: 'key_account_platform_management',
    title: 'key_account_transporter_delete_permission',
    type: 'KEY_ACCOUNT'
  }
}

export default localPermissions
